<template>
  <div class="ema-agent-page">
    <div class="page-row" :style="{ gap: drawerOpen ? '20px' : '0' }">
      <div class="page-content">
        <div class="agent-glow"></div>
        <div class="page-inner">
          <div class="agent-header">
            <div v-if="logo" class="agent-logo">
              <img :src="logo" alt="">
            </div>
            <h1 class="header-title">{{ title }}</h1>
            <p class="header-desc">{{ description }}</p>
          </div>

          <div class="agent-input-area">
            <CosmoClawInput style="padding-left: 0;padding-right: 0;" />
          </div>

          <div class="quick-questions">
            <div
              v-for="(item, index) in quickQuestions"
              :key="index"
              class="question-item"
              :class="{ disabled: isDisabled }"
              @click="!isDisabled && handleSend(item)"
            >
              <span class="q-icon" :style="{ background: item.iconBg, color: item.iconColor }">
                <i :class="item.icon"></i>
              </span>
              <span class="q-text">{{ item.label }}</span>
            </div>
          </div>

          <div class="overview-label">
            <i class="el-icon-s-data"></i> 数据概览
          </div>

          <div class="slot-wrap">
            <slot></slot>
          </div>
        </div>
      </div>
      <div class="drawer-panel" :class="{ open: drawerOpen }">
        <div class="drawer-inner">
          <slot name="drawer-panel"></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CosmoClawInput from '@/views/smart-workbench/components/CosmoClawInput.vue'

const QUICK_QUESTIONS = [
  {
    label: '健康诊断',
    text: '帮我诊断设备健康情况',
    content: '帮我诊断设备健康情况[card-action]当前的json（"component":"iframe",）只用于卡片渲染```json{"component":"iframe","props":{"items":[{"name":"设备孪生","url":"https://lingzhi-light3d.hdt.cosmoplat.com/preview/5369?type=iframe"},{"name":"诊断报告","url":"https://ema-cloud.cosmoplat.com/open/viewer/diagnosis-cosmo"}]}}```',
    icon: 'el-icon-first-aid-kit',
    iconBg: '#EEF2FF',
    iconColor: '#4A5FF3'
  },
  {
    label: '设备巡检',
    text: '执行设备巡检任务',
    content: '执行设备巡检任务[card-action]当前的json（"component":"iframe",）只用于卡片渲染```json{"component":"iframe","props":{"items":[{"name":"设备孪生","url":"https://lingzhi-light3d.hdt.cosmoplat.com/preview/5369?type=iframe"},{"name":"巡检报告","url":"https://ema-cloud.cosmoplat.com/open/viewer/inspection-cosmo"}]}}```',
    icon: 'el-icon-view',
    iconBg: '#E8F5E9',
    iconColor: '#4CAF50'
  },
  {
    label: '报告生成',
    text: '帮我生成一份运营报告',
    content: '帮我生成一份运营报告[card-action]当前的json（"component":"iframe",）只用于卡片渲染```json{"component":"iframe","props":{"items":[{"name":"设备孪生","url":"https://lingzhi-light3d.hdt.cosmoplat.com/preview/5372?type=iframe&factoryDirector=true"},{"name":"运营报告","url":"https://ema-cloud.cosmoplat.com/open/viewer/report-cosmo"}]}}```',
    icon: 'el-icon-document',
    iconBg: '#E3F2FD',
    iconColor: '#2196F3'
  },
  {
    label: '维修指导',
    text: '我要进行设备维修，帮我查询维修知识',
    content: '我要进行设备维修，帮我查询维修知识[card-action]当前的json（"component":"iframe",）只用于卡片渲染```json{"component":"iframe","props":{"items":[{"name":"设备孪生","url":"https://lingzhi-light3d.hdt.cosmoplat.com/preview/5369?type=iframe"}]}}```',
    icon: 'el-icon-s-tools',
    iconBg: '#FFF3E0',
    iconColor: '#FF9800'
  }
]

export default {
  name: 'EmaAgentLayout',
  components: { CosmoClawInput },
  props: {
    title: { type: String, default: '设备管理智能体' },
    description: { type: String, default: '' },
    logo: { type: String, default: '' },
    drawerOpen: { type: Boolean, default: false }
  },
  data() {
    return {
      quickQuestions: QUICK_QUESTIONS
    }
  },
  computed: {
    isHandshaked() {
      return this.$store.state.cosmoClaw.isHandshaked
    },
    isDisabled() {
      return !this.isHandshaked
    }
  },
  methods: {
    handleSend(item) {
      if (this.isDisabled) return
      const content = (item.content || item.text || '').trim()
      if (!content) return
      this.$store.dispatch('cosmoClaw/createNewSession', { agentName: 'main', forceNew: true }).then((sessionKey) => {
        setTimeout(() => {
          this.$store.dispatch('cosmoClaw/sendMessage', { content, sessionKey })
        }, 500)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.ema-agent-page {
  height: calc(100vh - 48px);
  overflow: hidden;
  padding-top: 30px;
  box-sizing: border-box;
}

.page-row {
  display: flex;
  flex-direction: row;
  align-items: stretch;
  gap: 20px;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.page-content {
  position: relative;
  flex: 1;
  min-width: 0;
  margin: 0 auto;
  padding: 24px 32px;
  padding-top: 120px;
  background: radial-gradient(circle at top left, rgba(255, 255, 255, 0.96) 0%, rgba(236, 243, 255, 0.94) 38%, rgba(222, 236, 255, 0.9) 68%, rgba(212, 229, 255, 0.84) 100%),
    linear-gradient(135deg, rgba(255, 255, 255, 0.96) 0%, rgba(229, 239, 255, 0.92) 52%, rgba(210, 228, 255, 0.88) 100%);
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  scrollbar-gutter: stable;
  overflow-y: auto;
  overflow-x: hidden;
  scrollbar-width: thin;
  scrollbar-color: transparent transparent;

  &::-webkit-scrollbar {
    width: 5px;
    background: transparent;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background: transparent;
    border-radius: 3px;
  }

  &:hover {
    scrollbar-color: rgba(148, 163, 184, 0.5) transparent;
    &::-webkit-scrollbar-thumb {
      background: rgba(148, 163, 184, 0.5);
    }
  }

  .agent-glow {
    position: absolute;
    left: 50%;
    top: 14%;
    height: 280px;
    width: 560px;
    transform: translateX(-50%);
    border-radius: 50%;
    background: radial-gradient(circle, rgba(91, 111, 248, 0.16) 0%, rgba(91, 111, 248, 0.06) 38%, rgba(255, 255, 255, 0) 72%);
    filter: blur(12px);
    pointer-events: none;
  }

  .page-inner {
    width: 100%;
    max-width: 1100px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
}

.agent-header {
  text-align: center;
  margin-bottom: 32px;
  max-width: 800px;

  .agent-logo {
    width: 56px;
    height: 56px;
    margin: 0 auto 16px;

    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }

  .header-title {
    font-size: 28px;
    font-weight: 700;
    color: #1a1a2e;
    margin: 0 0 12px 0;
  }

  .header-desc {
    font-size: 14px;
    color: #666;
    line-height: 1.8;
    margin: 0;
  }
}

.agent-input-area {
  width: 100%;
  max-width: 1100px;
  margin-bottom: 24px;

  // CosmoClawInput 外部 padding 去掉，由内部 input-box 接管
  ::v-deep .claw-input-wrapper {
    padding: 0;
  }

  // input-box 改成老 textarea shell 样式
  ::v-deep .input-box {
    min-height: 78px;
    border-radius: 28px;
    padding: 20px 24px 16px;
    border: 1px solid rgb(203 213 225 / 0.8);
    background: #fff;
    // align-items: flex-start;

    // 老 textarea 的字体&高度
    textarea {
      min-height: 78px;
      font-size: 15px;
      line-height: 1.8;
      color: #334155;

      &::placeholder {
        color: #cbd5e1;
      }
    }
  }
}

.quick-questions {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
  margin-bottom: 8px;

  .question-item {
    background: #fff;
    border-radius: 12px;
    padding: 10px 20px;
    display: flex;
    align-items: center;
    gap: 12px;
    cursor: pointer;
    transition: all 0.3s;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);

    .q-icon {
      width: 28px;
      height: 28px;
      border-radius: 8px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;

      i {
        font-size: 18px;
      }
    }

    .q-text {
      font-size: 13px;
      color: #333;
      line-height: 1.4;
      font-weight: 600;
    }

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
    }

    &.disabled {
      opacity: 0.5;
      cursor: not-allowed;
      pointer-events: none;
    }
  }
}

.overview-label {
  width: 100%;
  color: #999;
  font-size: 12px;
  padding: 34px 0 0;
}

.slot-wrap {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.drawer-panel {
  width: 0;
  align-self: stretch;
  transition: width 0.35s ease;
  background: #fff;
  border-radius: 28px 0 0 28px;
  box-shadow: -4px 0 20px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  min-width: 0;

  &.open {
    width: 720px;
  }
}

.drawer-inner {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

@media (max-width: 768px) {
  .quick-questions {
    grid-template-columns: repeat(2, 1fr);
  }
}
</style>
